import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { Reveal } from "./Reveal";

export function Section({
  children,
  className,
  tone = "dark",
  id,
  reveal = true,
}: {
  children: ReactNode;
  className?: string;
  tone?: "dark" | "darker" | "cream";
  id?: string;
  reveal?: boolean;
}) {
  const tones = {
    dark: "bg-background text-foreground",
    darker: "bg-surface text-foreground",
    cream: "bg-cream text-cream-foreground",
  } as const;
  return (
    <section id={id} className={cn(tones[tone], "py-12 md:py-16 lg:py-20", className)}>
      <div className="container-edge">
        {reveal ? <Reveal>{children}</Reveal> : children}
      </div>
    </section>
  );
}

export function SectionEyebrow({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <p className={cn("eyebrow mb-6", className)}>{children}</p>;
}
